import SayPlayDisplay from './SayPlayDisplay'
import SayPlayForm from './SayPlayForm.container'
import IconSpeak from 'components/Icons/Speak'

export default {
  id: 'say_play',
  label: 'Say/Play',
  helpUrl: 'https://help.thinkpickle.com.au/flows/actions/say-play',
  icon: IconSpeak,
  inputs: [{}],
  outputs: [{}],
  display: SayPlayDisplay,
  form: SayPlayForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SayPlay/index.js